<div class="step"
    [class.step--active]="step.isActive"
    [class.step--completed]="step.isCompleted">
    <span *ngIf="step.title === 'Basis'"
        class="step-title"
        i18n="@@step.Basis">Basis</span>
    <span *ngIf="step.title === 'Gegevens'"
        class="step-title"
        i18n="@@step.Gegevens">Gegevens</span>
    <i-check style="stroke: #003878;"></i-check>
</div>
